/** The ids of a contract's Owners or Managers. */
export function getAssigneeIds(assignees?: Array<{ id: number }>): number[] {
  return assignees?.map((assignee) => assignee.id) ?? [];
}

/** True when both lists hold the same people, whatever the order. */
export function haveSameAssignees(a: number[], b: number[]): boolean {
  return a.length === b.length && a.every((id) => b.includes(id));
}
